import script from "./BuscadorInput.vue?vue&type=script&setup=true&lang=js"
export * from "./BuscadorInput.vue?vue&type=script&setup=true&lang=js"

import "./BuscadorInput.vue?vue&type=style&index=0&id=74991c48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74991c48"]])

export default __exports__